import { MerchantId, SetHeaderService } from "@/helper/authenticationHelper";
import service from "../../baseHttpService";
import {
  PrepareDocumentInputData,
  PrepareDocumentPublicLinkInputData,
  PrepareUpdateDetailDocumentInputData,
} from "../documentFacade";

class PndService {
  DoGetPnd1DocumentPublicLink(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentPublicLinkInputData(input),
    };
    return service.peakOnlineView.post("/api/Pnd/GetPnd1DocumentPublicLink", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetPnd1Document(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentInputData(input),
    };
    return service.peakOnlineView.post("/api/Pnd/GetPnd1Document", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdatePnd1DetailDocument(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareUpdateDetailDocumentInputData(input),
    };
    return service.peakOnlineView.post("/api/Pnd/UpdatePnd1DetailDocument", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetPnd2Document(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentInputData(input),
    };
    return service.peakOnlineView.post("/api/Pnd/GetPnd2Document", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdatePnd2DetailDocument(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareUpdateDetailDocumentInputData(input),
    };
    return service.peakOnlineView.post("/api/Pnd/UpdatePnd2DetailDocument", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetPnd2DocumentPublicLink(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentPublicLinkInputData(input),
    };
    return service.peakOnlineView.post("/api/Pnd/GetPnd2DocumentPublicLink", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetPnd3DocumentPublicLink(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentPublicLinkInputData(input),
    };
    return service.peakOnlineView.post("/api/Pnd/GetPnd3DocumentPublicLink", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetPnd3Document(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentInputData(input),
    };
    return service.peakOnlineView.post("/api/Pnd/GetPnd3Document", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdatePnd3DetailDocument(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareUpdateDetailDocumentInputData(input),
    };
    return service.peakOnlineView.post("/api/Pnd/UpdatePnd3DetailDocument", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetPnd53DocumentPublicLink(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentPublicLinkInputData(input),
    };
    return service.peakOnlineView
      .post("/api/Pnd/GetPnd53DocumentPublicLink", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
  DoGetPnd53Document(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareDocumentInputData(input),
    };
    return service.peakOnlineView.post("/api/Pnd/GetPnd53Document", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoUpdatePnd53DetailDocument(input: any) {
    const _input = {
      merchantId: MerchantId(),
      data: PrepareUpdateDetailDocumentInputData(input),
    };
    return service.peakOnlineView.post("/api/Pnd/UpdatePnd53DetailDocument", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
}

export default new PndService();
